// Selos de um item aberto — os MESMOS em Minhas e na Lista: o que vence, o que é
// urgente, quando é. Puro (o repo não tem jsdom); o componente só desenha.

import { dataCurtaBR } from "./boletim-periodo.js";

export type TomSelo = "info" | "atencao" | "erro" | "neutro";

export interface Selo {
  chave: "atrasado" | "hoje" | "alta" | "data";
  texto: string;
  tom: TomSelo;
}

export interface ItemParaSelos {
  status: string;
  dataPrevista: string | null;
  atrasada: boolean;
  desde: string | null;
  prioridade: string;
}

export function selosDoItem(item: ItemParaSelos, hoje: string): Selo[] {
  if (item.status === "concluida" || item.status === "cancelada") return [];
  const selos: Selo[] = [];
  if (item.atrasada && item.desde) {
    selos.push({ chave: "atrasado", texto: `desde ${dataCurtaBR(item.desde)}`, tom: "erro" });
  } else if (item.dataPrevista === hoje) {
    selos.push({ chave: "hoje", texto: "hoje", tom: "info" });
  } else if (item.dataPrevista && item.dataPrevista > hoje) {
    selos.push({ chave: "data", texto: dataCurtaBR(item.dataPrevista), tom: "neutro" });
  }
  if (item.prioridade === "alta") selos.push({ chave: "alta", texto: "alta", tom: "atencao" });
  return selos;
}
